import { render, staticRenderFns } from "./SearchPeopleResult.vue?vue&type=template&id=04b687b2&"
import script from "./SearchPeopleResult.vue?vue&type=script&lang=js&"
export * from "./SearchPeopleResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports